// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Sdjv","requiredAsterisk":"Info_requiredAsterisk__1zl0C"};